import React, { useEffect, useState } from "react";
import { getEvents } from "../Service/Api";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import LazyLoad from "react-lazyload";
const HomeEvent = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  useEffect(() => {
    const fetchData = async () => {
      try {
        const eventData = await getEvents();
        setData(eventData);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const emptyArray = [
    {
      title: "International Workers’ Day",
      description: "Behind every success story is a tale of relentless effort and unwavering determination",
      date: "01 May",
      time: "08:30 AM",
      venue: "School Campus",
      img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/events.jpg"
    },
    {
      title: "World Laughter Day",
      description: "Let your laughter be the superhero cape that conquers the villain of stress in your life!",
      date: "04 May",
      time: "08:30 AM",
      venue: "School Campus",
      img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/events.jpg"
    },
    {
      title: "Rabindranath Tagore",
      description: "Let your life lightly dance on the edges of Time like dew on the tip of a leaf.",
      date: "07 May",
      time: "08:30 AM",
      venue: "School Campus",
      img: "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/events.jpg"
    }
  ];
  var settings = {
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows: false,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <>
      <div className="eventbg">
        <Slider {...settings}>
          {data && data.length > 0 ? data.map((item, index) => {
            const date = new Date(item.date);
            const mon = monthNames[date.getMonth()];
            const eventdate = date.getDate();
            console.log(mon);

            return (
              <div className="item" key={index}>
                <div className="homeeventbox">
                  <div className="homeeventboximg">
                    <p>
                      <span>
                        {item.venue}
                      </span>
                    </p>
                    {item.img ? (
                      <LazyLoad
                        offset={10}
                        placeholder={
                          <img
                            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/events.jpg"
                            alt="Loading..."
                            className="img-fluid"
                          />
                        }>
                        <img
                          src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.images}`}
                          className="img-fluid"
                          alt="Mata Mariyam Jan Sewa"
                        />
                      </LazyLoad>
                    ) : (
                      <img
                        src={`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.images}`}
                        className="img-fluid"
                        alt="Mata Mariyam Jan Sewa"
                      />
                    )}
                  </div>
                  <div className="homeeventboxdesc">
                    <div className="homeeventboxtitle">
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                      <div className="homeeventboxbottom">
                        <span>
                          {eventdate}, {mon}{" "}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })
            : emptyArray.map((item, index) => (
              <div className="item" key={index}>
                <div className="homeeventbox">
                  <div className="homeeventboximg">
                    <p> <span> {item.venue}  </span>
                    </p>
                    <LazyLoad><img src={item.img} className="img-fluid" alt="Mata Mariyam Jan Sewa" /></LazyLoad>
                  </div>
                  <div className="homeeventboxdesc">
                    <div className="homeeventboxtitle">
                      <h3>{item.title}</h3>
                      <p>{item.description}</p>
                      <div className="homeeventboxbottom">
                        <span>{item.date} </span>
                        <span>{item.time}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </Slider>
        <div className="arrow-button"><a href="/Events"><i className="bi bi-arrow-right"></i></a></div>
      </div>
    </>
  );
};

export default HomeEvent;
